export const categoryIdToName: Record<string, string> = {
  'video-plugins': 'Video Plugin',
  subscriptions: 'Subscription',
  bundles: 'Bundle',
  upgrades: 'Upgrade',
  'photo-plugins': 'Photo Plugin',
};
